<template>
  <form>
    <YourPlan />
    <CreditCardSection />
    <PaymentHistory />
  </form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import YourPlan from "./plan/YourPlan.vue";
import CreditCardSection from "./plan/CreditCardSection";
import PaymentHistory from "./plan/PaymentHistory";

export default {
  name: "PlanAndBilling",
  components: { YourPlan, CreditCardSection, PaymentHistory },
};
</script>

<style></style>
